import HttpService from "common/http/httpService";
import CropYear from "domain/cropYear";


class CropYearsService extends HttpService {
    async listCropYears(commodityId: number = null): Promise<CropYear[]> {
        const response = await this.getClient().get<CropYear[]>('/settings/v1/crop-years', {
            params: {
                commodityId: commodityId
            }
        });
        return response.data;
    }
}
const cropYearsService = new CropYearsService();
export default cropYearsService;
